import React from 'react';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import moment from 'moment';
import { Avatar, Divider } from '@mui/material';
export const CommentConttentAllComments = ({ comment, user, commentsales }) => {
  let projectname = '';
  let developername = '';
  let stagename = '';

  if (user) {
    if (user.project) {
      projectname = user.project.name;
      developername = user.project.developer.name;
    } else {
      projectname = '';
    }
  }

  if (user && user.stage) {
    stagename = user.stage.name;
  } else {
    stagename = '';
  }
  return (
    <div className="" style={{ background: '#fff', borderRadius: '15px' }}>
      {/* <div className='w-100 d-flex' style={{fontWeight:'bold',fontSize:'20px'}}><PersonOutlineIcon/>{comment&&comment.sales?(comment.sales.name):null}</div>
    <div>First Action</div> */}
      {/* <div className='w-100 d-flex ' style={{color:'#0F7687',fontSize:'15px'}}> <div style={{wordBreak:'break-all',overflowWrap:'break-word'}}>{comment&&comment.firstcomment?(comment.firstcomment.text):null}</div></div>
    <div className='w-100 d-flex justify-content-end ' style={{color:'royalblue',fontSize:'11px'}}><AccessAlarmsIcon style={{fontSize:'15px'}}/> Created At :  {comment&&comment.firstcomment?moment((comment.firstcomment.date)).format('DD/MM/YYYY h:mm A'):null} </div> */}

      {/* <div class="commentcard my-2" style={{width:'100%'}}>
<div class="container1">
<div class="left">
  <div class="status-ind"></div>
</div>
<div class="right">
  <div class="text-wrap">
    <p class="text-content">
      <div class="text-link"><div className='w-100 d-flex' style={{fontWeight:'bold',fontSize:'20px'}}><PersonOutlineIcon/>{comment&&comment.sales?(comment.sales.name):null}</div></div> <div style={{color:'white'}}>First Comment</div>
      <div class="text-link"><div className='w-100 d-flex ' style={{fontSize:'15px'}}> <div style={{wordBreak:'break-all',overflowWrap:'break-word'}}>{comment&&comment.firstcomment?(comment.firstcomment.text):null}</div></div></div>
    </p>
    <p class="time">        <div className='w-100 d-flex justify-content-start ' style={{fontSize:'11px'}}><AccessAlarmsIcon style={{fontSize:'15px'}}/> Created At :  {comment&&comment.firstcomment?moment((comment.firstcomment.date)).format('DD/MM/YYYY h:mm A'):null} </div></p>
  </div>
 
</div>
</div>
</div> */}

      <div
        className="comment-section"
        style={{ background: 'white', padding: '16px', borderRadius: '8px', marginBottom: '20px' }}
      >
        <div style={{ color: '#666', fontWeight: '600', fontSize: '15px' }}>Comment</div>
        <div style={{ margin: '6px 0', fontSize: '14px', color: '#000' }}>
          {comment?.firstcomment?.text}
        </div>
        <div className="text-muted" style={{ fontSize: '11px', textAlign: 'right', color: 'gray' }}>
          <AccessAlarmsIcon style={{ fontSize: '14px', marginRight: '4px' }} />
          {comment?.firstcomment?.date
            ? moment(comment.firstcomment.date).format('DD/MM/YYYY, h:mm A')
            : null}
        </div>
      </div>

      {/* <hr/> */}
      {/* <div>Second Action</div>
    <div className='w-100 d-flex ' style={{color:'#0F7687'}}><div  style={{wordBreak:'break-all',overflowWrap:'break-word'}}> {comment&&comment.secondcomment?(comment.secondcomment.text):null} .</div></div>
    <div className='w-100 d-flex justify-content-end ' style={{color:'royalblue',fontSize:'11px'}}><AccessAlarmsIcon  style={{fontSize:'15px'}}/> Next Date And Time : {comment&&comment.secondcomment?moment((comment.secondcomment.date)).format('DD/MM/YYYY h:mm A'):null}</div> */}

      {/* <div class="commentcard" style={{width:'100%'}}>
<div class="container1">
<div class="left">
  <div class="status-ind2"></div>
</div>
<div class="right">
  <div class="text-wrap">
    <p class="text-content" style={{color:'white'}}>
       Second Comment
       <div className='w-100 d-flex ' style={{color:'#0F7687'}}><div  style={{wordBreak:'break-all',overflowWrap:'break-word'}}> {comment&&comment.secondcomment?(comment.secondcomment.text):null} .</div></div>
       </p>
       <div className='w-100 d-flex justify-content-start time my-2' style={{fontSize:'11px',fontWeight:'bold'}}><AccessAlarmsIcon  style={{fontSize:'15px'}}/> Next Date And Time : {comment&&comment.secondcomment?moment((comment.secondcomment.date)).format('DD/MM/YYYY h:mm A'):null}</div>      </div>
 
</div>
</div>
</div> */}

      <div
        className="comment-section"
        style={{ background: '#fff', padding: '16px', borderRadius: '8px', marginBottom: '20px' }}
      >
        <div style={{ color: '#666', fontWeight: '600', fontSize: '15px' }}>Action (Plan)</div>
        <div style={{ margin: '6px 0', fontSize: '14px', color: '#000' }}>
          {comment?.secondcomment?.text}
        </div>
        <div className="text-muted" style={{ fontSize: '11px', textAlign: 'right', color: 'gray' }}>
          <AccessAlarmsIcon style={{ fontSize: '14px', marginRight: '4px' }} />
          {comment?.secondcomment?.date
            ? moment(comment.secondcomment.date).format('DD/MM/YYYY, h:mm A')
            : null}
        </div>
      </div>

      <hr style={{ color: '#666' }} />

      {/* All Replayes */}
      {/* <div class="commentcard my-3" style={{width:'100%'}}>
  <div class="container1">
    </div>
        <div style={{width:'100%'}}>
        <div className='my-2 w-100 d-flex justify-content-center' style={{color:'white'}}>All Replies On The Comment</div> 
           <div className='w-100  ' style={{color:'white'}}><div className='w-100'> {comment&&comment.replies?(comment.replies.map((replay,index)=>{return(
             <div className='my-3' style={{border:'2px solid white',borderRadius:'15px',width:'100%'}}>
            
            
             <div className='d-flex justify-content-between flex-wrap' key={index}>

             <div className='d-flex align-items-center mx-1'>
    {replay?.user && (
        <>
            <Avatar
                alt={replay.user.name} 
                src={replay.user.profileImg || '/default-avatar.png'} 
                sx={{ width: 32, height: 32, marginRight: 1 }}
            />
            <p className='m-2' style={{ color: 'royalblue', fontWeight: 'bold' }}>
                {replay.user.name}
            </p>
            <div className='' style={{color:'royalblue'}}>{replay.user.role}</div>
        </>
    )}
</div>

              <div className='m-2'> Date : {replay.date?moment(replay.date).format('DD/MM/YYYY h:mm A'):null}</div>
              </div>

              <Divider/>
              <div className='m-2'> Replay : {replay.text}</div>

     
          </div>
            
           )})):null} </div></div>
        </div>
   
    </div>


<div className='d-flex justify-content-center' style={{marginTop:'40px'}}>
<div className='commentcardfooter mx-3'>{developername}</div>
<div className='mx-3 commentcardfooter'>{projectname}</div>
<div className='mx-3 commentcardfooter'>Current Stage : <span style={{fontWeight:'bold',color:'orange'}}>{stagename}</span></div>
<div className='mx-3 commentcardfooter'>Stage For This Comment : <span style={{fontWeight:'bold',color:'orange'}}>{comment?.stage?.name}</span></div>




</div> */}

      {/* All Replayes */}
      {/* <div class="commentcard" style={{width:'100%'}}>
  <div class="container1">
    </div>
        <div style={{width:'100%'}}>
        <div className='my-2 w-100 d-flex justify-content-center' style={{color:'white'}}>All Replies On The Comment</div> 
           <div className='w-100  ' style={{color:'white'}}><div className='w-100'> {comment&&comment.replies?(comment.replies.map((replay,index)=>{return(
             <div className='my-3' style={{border:'2px solid white',borderRadius:'15px',width:'100%'}}>
            
            
             <div className='d-flex justify-content-between flex-wrap' key={index}>

             <div className='d-flex align-items-center mx-1'>
    {replay?.user && (
        <>
            <Avatar
                alt={replay.user.name} 
                src={replay.user.profileImg || '/default-avatar.png'} 
                sx={{ width: 32, height: 32, marginRight: 1 }}
            />
            <p className='m-2' style={{ color: 'orange', fontWeight: 'bold' }}>
                {replay?.user?.name}
            </p>
            <div className='' style={{color:'orange'}}>{replay?.user?.role}</div>
        </>
    )}
</div>

              <div className='m-2'> Date : {replay.date?moment(replay.date).format('DD/MM/YYYY h:mm A'):null}</div>
              </div>

              <Divider/>
              <div className='m-2'> Replay : {replay.text}</div>

     
          </div>
            
           )})):null} </div></div>
        </div>
   
    </div> */}
      <div style={{ marginTop: '30px' }}>
        <div className="text-center fw-bold" style={{ color: '#666', marginBottom: '12px' }}>
          Comment Replies
        </div>

        {/* {comment?.replies?.map((replay, index) => (
    <div key={index} style={{ background: '#fff', padding: '12px', borderRadius: '10px', marginBottom: '12px' }}>
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div className="d-flex align-items-center">
          <Avatar src={replay?.user?.profileImg || '/default-avatar.png'} sx={{ width: 32, height: 32, marginRight: 1 }} />
          <div>
            <div style={{ fontWeight: 'bold', color: '#0F7687' }}>{replay?.user?.name}</div>
            <div style={{ fontSize: '12px', color: 'gray' }}>{replay?.user?.role}</div>
          </div>
        </div>
        <div style={{ fontSize: '11px', color: 'gray' }}>
          <AccessAlarmsIcon style={{ fontSize: '14px', marginRight: '4px' }} />
          {replay?.date ? moment(replay.date).format('DD/MM/YYYY, h:mm A') : null}
        </div>
      </div>
      <div style={{ fontSize: '14px', color: '#333' }}>
        {replay?.text}
      </div>
    </div>
  ))} */}

        {comment?.replies?.length > 0 ? (
          comment.replies.map((replay, index) => (
            <div
              key={index}
              style={{
                background: '#fff',
                padding: '12px',
                borderRadius: '10px',
                marginBottom: '12px',
              }}
            >
              <div className="d-flex justify-content-between align-items-center mb-2">
                <div className="d-flex align-items-center">
                  <Avatar
                    src={replay?.user?.profileImg || '/default-avatar.png'}
                    sx={{ width: 32, height: 32, marginRight: 1 }}
                  />
                  <div>
                    <div style={{ fontWeight: 'bold', color: '#666' }}>{replay?.user?.name}</div>
                    <div style={{ fontSize: '12px', color: 'gray' }}>{replay?.user?.role}</div>
                  </div>
                </div>
                <div style={{ fontSize: '11px', color: 'gray' }}>
                  <AccessAlarmsIcon style={{ fontSize: '14px', marginRight: '4px' }} />
                  {replay?.date ? moment(replay.date).format('DD/MM/YYYY, h:mm A') : null}
                </div>
              </div>
              <div style={{ fontSize: '14px', color: '#333' }}>{replay?.text}</div>
            </div>
          ))
        ) : (
          <div style={{ textAlign: 'center', color: 'gray', marginTop: '10px' }}>
            No replies Found
          </div>
        )}
      </div>

      {/* ============================================================ */}
      <hr style={{ color: '#666' }} />

      <div className="commentfooter" style={{ marginTop: '10px' }}>
        <div className="w-100" style={{ marginTop: '10px' }}>
          <div className="d-flex flex-wrap w-100 my-3">
            <div
              className="commentcardfooter mx-3 mb-3"
              style={{
                width: 'calc(48% - 1.5rem)',
                textAlign: 'center',
                background: '#ccc',
                color: '#666',
                fontSize: '13px',
              }}
            >
              {developername}
            </div>
            <div
              className="commentcardfooter mx-3 mb-3"
              style={{
                width: 'calc(48% - 1.5rem)',
                textAlign: 'center',
                background: '#ccc',
                color: '#666',
                fontSize: '13px',
              }}
            >
              {projectname}
            </div>
            <div
              className="commentcardfooter mx-3 mb-3"
              style={{
                width: 'calc(48% - 1.5rem)',
                textAlign: 'center',
                background: '#ccc',
                color: '#666',
                fontSize: '13px',
              }}
            >
              Current Stage:{' '}
              <span style={{ fontWeight: 'bold', color: 'royalblue' }}>{stagename}</span>
            </div>
            <div
              className="commentcardfooter mx-3 mb-3"
              style={{
                width: 'calc(48% - 1.5rem)',
                textAlign: 'center',
                background: '#ccc',
                color: '#666',
                fontSize: '13px',
              }}
            >
              Stage For Comment:{' '}
              <span style={{ fontWeight: 'bold', color: 'royalblue' }}>{comment?.stage?.name}</span>
            </div>
          </div>
        </div>
      </div>

      <hr style={{ color: '#666' }} />
    </div>
  );
};
